<template>
  <svg
    height="100%" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:2;"
    version="1.1" viewBox="0 0 625 625" width="100%"
    xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:serif="http://www.serif.com/"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <path d="M625,625l-312.5,-312.5l-312.5,312.5l625,0Z" :style="fillStyle.bottom" />
    <path d="M312.5,312.5l-312.5,-312.5l625,0l-312.5,312.5Z" :style="fillStyle.top" />
    <path d="M625,0l0,625l-312.5,-312.5l312.5,-312.5Z" :style="fillStyle.right" />
    <path d="M312.5,312.5l-312.5,-312.5l0,625l312.5,-312.5Z" :style="fillStyle.left" />
  </svg>
</template>


<script>
export default {
  props: {
    id: Number,
    fillStyle: Object,
  },
};
</script>
